import React, {useContext} from 'react'
import {makeStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import {StageSections, StageSectionsOrder} from "../constants/StageSections";
import OfferExpansionSections from "./common/OfferExpansionSections";
import DefineOfferPasswordPopup from "./common/DefineOfferPasswordPopup";
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import Button from "components/Button";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import GridBlock from "components/GridBlock";
import Tr from "translations/Translations"
import PurchaserOfferContext from "context/PurchaserOfferContext";
import RouterPath from "libs/RouterPath";
import {useParams} from "react-router";


const useStyle = makeStyles(theme => ({
    root: {
        height: '100%',
        '&>*:not(:first-child)': {
            marginTop: theme.spacing(2)
        }
    }
}))

function OfferSections(
    {
        demandStageSectionsList
    }) {
    const classes = useStyle();
    const purchaserOfferContext = useContext(PurchaserOfferContext)
    const params = useParams();
    const demandId = params.id;

    const backClick = () => {
        if(demandStageSectionsList[StageSections.DASHBOARD].oldPlatformOfferTabUrl) {
            window.location.href = demandStageSectionsList[StageSections.DASHBOARD].oldPlatformOfferTabUrl;
        } else {
            RouterPath.redirect(RouterPath.createPath(RouterPath.myProcedure.steps.MP_3_ID, {id: demandId}));
        }
    }

    return (
        <div className={classes.root}>
            {
                purchaserOfferContext && <GridBlock justify="flex-end">
                <Button onClick={backClick} Icon={ArrowBackIosIcon} variant={"outlined"}>{Tr("back_to_demand")}</Button>
            </GridBlock>
            }
            {StageSectionsOrder.filter((sectionId) => {
                const section = demandStageSectionsList[sectionId];
                return !!section && section.status !== DemandValidationSectionStatus.UNAVAILABLE
            })
                .map((sectionId) => {
                    return (<OfferExpansionSections key={sectionId} section={demandStageSectionsList[sectionId]}/>)
                })}

            <DefineOfferPasswordPopup />
        </div>
    )
}

OfferSections.propTypes = {
    classes: PropTypes.any,
}

export default OfferSections;